import React from "react"

export default function AbbreviateNumber(props) {
	let o = Intl.NumberFormat('en', { notation: 'compact' });
  return <span>{o.format(props.number)}</span>
}